export const getFlexBoxAlignType = (type: IFlexBoxAlignTypes) => {
  const flexboxMap = new Map()

  flexboxMap.set('TOP', 'flex-start')
  flexboxMap.set('BOTTOM', 'flex-end')
  flexboxMap.set('CENTER', 'center')
  flexboxMap.set('STRETCH', 'stretch')

  return (type && flexboxMap.get(type)) || 'center'
}

export type IFlexBoxAlignTypes = 'TOP' | 'BOTTOM' | 'CENTER' | 'STRETCH'

export const mapFlexAlignTextAndItems = (
  type: FlexItemsAlignment = 'start',
) => {
  return !type || type === 'start' ? 'start' : 'center'
}

export type FlexItemsAlignment = 'start' | 'center'
